'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _Add = require('material-ui-icons/Add');

var _Add2 = _interopRequireDefault(_Add);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _ = require('../../..');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CreateObjectLink = (_temp = _class = function (_EditorComponent) {
  _inherits(CreateObjectLink, _EditorComponent);

  function CreateObjectLink() {
    _classCallCheck(this, CreateObjectLink);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  }

  CreateObjectLink.prototype.renderPanelView = function renderPanelView() {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, _react2.default.createElement('div', {
      className: classes.panelButton
    }, _react2.default.createElement(_Add2.default, null), ' Create Object'));
  };

  CreateObjectLink.prototype.renderChildren = function renderChildren() {
    var _getEditorContext2 = this.getEditorContext(),
        inEditMode = _getEditorContext2.inEditMode;

    var _getComponentProps = this.getComponentProps(this),
        to = _getComponentProps.to;

    if (!to) {
      if (inEditMode) {
        return _react2.default.createElement(_Typography2.default, {
          color: 'error'
        }, '"to" property required');
      } else {
        return null;
      }
    }

    var children = _EditorComponent.prototype.renderChildren.call(this);

    return _react2.default.createElement(_reactRouterDom.Link, {
      to: to
    }, children && children.length ? children : _react2.default.createElement(_IconButton2.default, {
      title: 'Add object'
    }, _react2.default.createElement(_Add2.default, null)));
  };

  return CreateObjectLink;
}(_2.default), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  to: "",
  hide_wrapper_in_default_mode: true
}), _class.Name = "CreateObjectLink", _temp);
exports.default = CreateObjectLink;
module.exports = exports['default'];